import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { CheckClientEvrotrustInterface, CheckClientEvrotrustEnum } from '../interfaces/evrotrust/ckeck-client-evrotrust.interface';
import { CreateDocumentsSigningInterface } from '../interfaces/evrotrust/create-documents-signing.interface';
import { GetDocumentsStatusInterface } from '../interfaces/evrotrust/get-documents-status.interface';

@Injectable({
  providedIn: 'root'
})
export class EvrotrustService {

  private readonly BASE_URL = '/api/v1/evrotrust'
  DOCUMENT_STATUS_DELAY = 3000;
  isLoading = false;

  constructor(private http: HttpClient) { }


  checkUser(nationalId: string) {
    return this.http.post<CheckClientEvrotrustInterface>(`${this.BASE_URL}/check-user`, { nationalId }).pipe(
        map((data) => {
          if (
            data.hasConfirmedPhone === CheckClientEvrotrustEnum.hasConfirmedPhone &&
            data.isRegistered === CheckClientEvrotrustEnum.isRegistered &&
            data.isIdentified === CheckClientEvrotrustEnum.isIdentified &&
            data.isReadyToSign === CheckClientEvrotrustEnum.isReadyToSign &&
            data.isRejected === CheckClientEvrotrustEnum.isRejected
          ) {
            return true;
          } else {
            return false;
          }
        }),

      );
  }

  createDocumentsSigning(docId, userId) {

    const params = new HttpParams().set('dateTo', '01.01.2020').set('userId', userId).set('isFromSocket', true)
    return this.http.get<CreateDocumentsSigningInterface>(`${this.BASE_URL}/doc/`+docId, {params})
  }

  getDocumentsStatus(threadId: string) {
    const params = new HttpParams().set('threadId', threadId);
    return this.http.get<GetDocumentsStatusInterface>(`${this.BASE_URL}/get-documents-status`, {
      params,
    });
  }

  withdrawDocuments(threadID: string) {
    return this.http.post(`${this.BASE_URL}/withdraw/${threadID}`, {})
  }

  saveDocumentsToBPM(docId: any, transactionID: string) {
    const params = new HttpParams().set('docId', docId).set('transactionID', transactionID);
    return this.http.get(`${this.BASE_URL}/download-save-bpm`, {params})
  }
}
